import Masonry from "@mui/lab/Masonry";
import { createTheme, ThemeProvider } from "@mui/material";

declare module "@mui/material/styles" {
	interface BreakpointOverrides {
		xs: true;
		sm: true;
		md: true;
		lg: true;
		xl: true;
	}
}
const theme = createTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 640,
			md: 740,
			lg: 1200,
			xl: 1700,
		},
	},
});

import styles from "./VerticalMasonry.module.css";
import Image from "next/image";
import imgUrlFor from "../functions/imgUrlFor";

export default function VerticalMasonry({ value }: { value: any }) {
	return (
		<div className={`${styles.gallery}`}>
			<ThemeProvider theme={theme}>
				<Masonry
					columns={{ sm: 1, md: 2, lg: 3, xl: 4 }}
					spacing={4}
					sx={{ width: "auto" }}>
					{value?.images.map((image: any, index: number) => (
						<div className={styles.imgWrapper}>
							<Image
								height={0}
								width={1600}
								key={index}
								alt={image.alt || " "}
								loading="lazy"
								src={
									imgUrlFor(image).width(1600).auto("format").url() as string
								}
							/>{" "}
						</div>
					))}
				</Masonry>
			</ThemeProvider>
		</div>
	);
}
